import VideoSlider from "components/video/VideoSlider"
import { ShortsVideo } from "types/event"



interface IVideos {
    videos: ShortsVideo[]
}
export const RenderStory = ({
    videos
}: IVideos) => {



    return videos && videos.length > 0
        && videos.map((video, index) => (
            <div
                key={`${index}`}
                className={`md:max-w-[1230px]`}
            >
                <VideoSlider videos={videos}  video={video}
                   />
            </div>
        ))
}

export default RenderStory